import { addObjectToFormData } from '@d-shared/forms/forms';
import AHttpService from '@d-services/a-http-service/a-http-service';
import DropdownOptionsHelper from '@d-helpers/dropdown-options-helper';
import URLS from '@d-shared/urls/urls';

class GenresService extends AHttpService {
  async getFeaturedGenres(asOptions = false) {
    const response = await this._http.get(URLS.api.genres.featured);
    const genres = response.data.genres;
    if (!asOptions) {
      return genres;
    }

    return DropdownOptionsHelper.getListAsOptions(genres, 'genres');
  }

  async getGenres(asOptions = false, ignoreRootGenres = false) {
    const response = await this._http.get(URLS.api.genres.all);
    const genres = response.data.genres;
    if (!asOptions) {
      return genres;
    }

    let genresList = DropdownOptionsHelper.getListAsOptions(genres, 'genres');
    if (!ignoreRootGenres) {
      return genresList;
    }

    return DropdownOptionsHelper.getNonRootOptions(genresList);
  }

  async getPopularGenres(asOptions = false, ignoreLabels = false) {
    const response = await this._http.get(URLS.api.genres.popular);
    const genres = response.data.genres;
    if (!asOptions) {
      return genres;
    }

    return DropdownOptionsHelper.getListAsOptions(genres, 'genres', ignoreLabels);
  }

  async getUserGenres() {
    const response = await this._http.get(URLS.api.userGenres.all);
    const genresList = DropdownOptionsHelper.getListAsOptions(response.data.genres);
    return genresList;
  }

  async getUserSecondLevelGenres() {
    const response = await this._http.get(URLS.api.userGenres.secondLevel);
    const genresList = DropdownOptionsHelper.getListAsOptions(response.data.genres);
    return genresList;
  }

  async saveUserGenres(genreIds) {
    const idsData = {
      ids: genreIds,
    };
    const formData = new FormData();
    addObjectToFormData(idsData, formData);
    const response = await this._http.post(URLS.api.userGenres.saveBulk, formData);
    return response.data;
  }
}

export default new GenresService();
